
import { defineComponent } from "vue";
import Spinner from "@/components/Spinner.vue";

export default defineComponent({
  components: {
    Spinner,
  },
});
